import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { MenuItem } from '../definition';
import { mmLanguageConstants } from '../language-constants';
import { MmHttpClient } from '../../http/http-client.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MmLanguageApiService {

  constructor(private httpClient: MmHttpClient) {

  }

  getTranslations() {
    return this.httpClient.get<any[]>(`${mmLanguageConstants.menuApiRoute}/translations`);
  }
}
